/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Priced_FilterInputs */

const id_tld_pricing_priced_filter = /** @type {(inputs: Tld_Pricing_Priced_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saring status harga`)
};

const en_tld_pricing_priced_filter = /** @type {(inputs: Tld_Pricing_Priced_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by pricing`)
};

/**
* | output |
* | --- |
* | "Filter by pricing" |
*
* @param {Tld_Pricing_Priced_FilterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_priced_filter = /** @type {((inputs?: Tld_Pricing_Priced_FilterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Priced_FilterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_priced_filter(inputs)
	return id_tld_pricing_priced_filter(inputs)
});